import { SNOWPLOW_SCRIPT_INTEGRITY, SNOWPLOW_SCRIPT_SRC } from "./constants";

export function getSnowplowLoaderSnippet(globalName: string): string {
  return `;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
};p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
n.integrity=${JSON.stringify(SNOWPLOW_SCRIPT_INTEGRITY)};n.crossOrigin="anonymous";
n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script",${JSON.stringify(
    SNOWPLOW_SCRIPT_SRC,
  )},${JSON.stringify(globalName)}));`;
}
